export default "__VITE_ASSET__Nll9khSe__ 480w, __VITE_ASSET__CyiMcQ$a__ 768w, __VITE_ASSET__C4WPyhrN__ 1200w, __VITE_ASSET__DEb5$2Te__ 1600w";